export function removeProtocolFromUrl(url: string): string {
    if (url?.startsWith('http://')) {
        return url.slice(7, -1);
    } else if (url?.startsWith('https://')) {
        return url.slice(8, -1);
    }

    return url;
}
